exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflow-steps-container[data-v-88624192]{height:100%;background:#e4edfa}.workflow-steps-container .workflow-title[data-v-88624192]{background:#e4edfa;font-size:1.3rem;padding:5px 20px;font-weight:bold}.workflow-steps-container .component[data-v-88624192]{background:#e4edfa}.workflow-steps-container .step-item[data-v-88624192]{height:100%}.fade-enter-active[data-v-88624192],.fade-leave-active[data-v-88624192]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-88624192],.fade-leave-to[data-v-88624192]{opacity:0}", ""]);

// exports
